import React, { useState, useEffect, useRef  } from 'react'
import './edit.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, collection, addDoc, doc, getDoc, updateDoc} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate, useParams } from "react-router-dom"
import { TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


const Edit = () => {

  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const {coinId} = useParams()

  const [like, setLike] = useState("")

  const [invitefriend, setInviteFriend] = useState("")

  const [inviteOutlet, setInviteOutlet] = useState("")

  const [status, setStatus] = useState("active")

  const [createdAt, setCreatedAt] = useState(new Date())

  const [errorLike, setErrorLike] = useState(false)

  const [errorInviteFriend, setErrorInviteFriend] = useState(false)

  const [errorInviteOutlet, setErrorInviteOutlet] = useState(false)

  

  const navigate = useNavigate();



    const getPoint = async() => {

      const docRef = doc(db, "pointcenter", coinId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setLike(docSnap.data().like)
        setInviteFriend(docSnap.data().invitefriend)
        setInviteOutlet(docSnap.data().inviteOutlet)
    
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
  }



  useEffect(()=>{

    getPoint()

  }, [])



    
    const handlePoints = async(e) => {
  
      e.preventDefault()

      if(like === ""){
        
        return setErrorLike("Like is required")
      }

       if(invitefriend === ""){
        
        return setErrorInviteFriend("Invite Friend is required")
      }

       if(inviteOutlet === ""){
        
        return setErrorInviteOutlet("Invite Outlet is required")
      }

      
      setIsloading(true)
  
      try{
           
          await updateDoc(doc(db, "pointcenter", coinId), {
    
            like: like,
            invitefriend: invitefriend,
            inviteOutlet: inviteOutlet,
            status: status,
            createdAt : today,
    
          })
          
        setIsloading(false)

        navigate("/coin")
        
      }catch (err) {

        console.log(err);

      } 
  
    }

    const handleLike = (e) => {

          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setLike(onlyNums)

         if(like !== ""){

          setErrorLike(false)
          
         }

    }

    
    const handleInvitefriend = (e) => {

         
          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setInviteFriend(onlyNums )

         if(invitefriend!== ""){

          setErrorInviteFriend(false)
          
         }

    }

    const handleInviteOutlet = (e) => {

         
          const { value } = e.target;

          const onlyNums = value.replace(/[^0-9]/g, ''); 

         setInviteOutlet(onlyNums )

         if(inviteOutlet !== ""){

          setErrorInviteOutlet(false)
          
         }

    }



  return (
    <div className="new">
      {/* {isloading && <Spinner />} */}
      <Sidebar/>
      <div className="newContainer">
      <Navbar/>
        <div className='top'>
          <div className='topLeft'><h1>Edit Point</h1></div>
          
          <div className='topRight'>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/coin"
            >
              Point List
            </Link>
            <Typography color="green">Edit Point</Typography>
          </Breadcrumbs>
          </div>
        </div>
        <div className='bottom'>
       
        <div className='right'>
          <div className='form'>

                <div style={{display: 'flex', flexDirection:'row', width: '100%', gap:20, flexWrap:'wrap'}}>


                  
                  
                    <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          // inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} 
                          name="like"
                          placeholder="Enter Like Point eg 60"
                          value={like}
                          onChange={handleLike}
                          style={{width:'100%', backgroundColor:'#f9e3ff'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorLike &&

                          <p style={{color:'red', fontSize:15, }}>{errorLike}</p>

                        }

                    </div>

                    <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="invitefriend"
                          placeholder="Enter Invite Friend Point eg 80"
                          value={invitefriend}
                          onChange={handleInvitefriend}
                          style={{width:'100%', backgroundColor:'#f9e3ff'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorInviteFriend &&

                          <p style={{color:'red', fontSize:15, }}>{errorInviteFriend}</p>

                        }

                    </div>

                    <div style={{width:'32%', flexDirection:'column'}}>

                      <TextField
                          name="inviteOutlet"
                          placeholder="Enter Invite Outlet Point eg 80"
                          value={inviteOutlet}
                          onChange={handleInviteOutlet}
                          style={{width:'100%', backgroundColor:'#f9e3ff'}}
                          variant="outlined" 
                          sx={{ "& fieldset": { border: "none" } }} 
                        />

                        {
                          errorInviteOutlet &&

                          <p style={{color:'red', fontSize:15, }}>{errorInviteOutlet}</p>

                        }

                    </div>

                </div>

                <hr style={{width:'100%', height:0, color:'$eee'}}/>

                  <Button 
                  
                    onClick={handlePoints} 
                    disabled={isloading}
                    style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>
                    {isloading ? '...loading Point' : 'Update Points'}
                    
                  </Button>

          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default Edit





// import React, { useState, useEffect, useRef  } from 'react'
// import './edit.scss'
// import Sidebar from '../../../components/sidebar/Sidebar'
// import Navbar from '../../../components/navbar/Navbar'
// import {serverTimestamp, collection, addDoc, doc, getDoc, updateDoc, deleteField} from "firebase/firestore";
// import { db, storage } from "../../../firebase";
// import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
// import Typography from '@mui/material/Typography';
// import Breadcrumbs from '@mui/material/Breadcrumbs';
// import Link from '@mui/material/Link';
// import { useNavigate, useParams } from "react-router-dom"
// import { TextField, Button } from '@mui/material';

// import Box from '@mui/material/Box';


// const Edit = () => {

//   const [isloading, setIsloading ] = useState(false)

//   const today = new Date().toDateString()

//   const {rewardId} = useParams()

//   const [title, setTitle] = useState("")

//   const [description, setDescription] = useState("")

//   const [coin, setCoin] = useState("")

//   const [price, setPrice] = useState("")

//   const [imgactive, setImgactive] = useState("")

//   const [imginactive, setImginactive] = useState("")

//   const [status, setStatus] = useState("active")

//   const [redeemStatus, setRedeemStatus] = useState(false)

//   const [externalStatus, setExternalStatus] = useState(false)

//   const [width, setWidth] = useState("")

//   const [height, setHeight] = useState("")

//   const [createdAt, setCreatedAt] = useState(new Date())

//   const [ perc, setPerc ] = useState(null)
  
//   const [activefile, setactivefile ] = useState("")

//   const [inactivefile, setinactivefile ] = useState("")

//   const [rewardImage, setRewardImage] = useState("")

//   const [errorTitle, setErrorTitle] = useState(false)

//   const [errorDescription, setErrorDescription] = useState(false)

//   const [errorCoin, setErrorCoin] = useState(false)

//   const [errorPrice, setErrorPrice] = useState(false)

//   const [errorWidth, setErrorWidth] = useState(false)

//   const [errorHeight, setErrorHeight] = useState(false)

//   const [errorimgactive, setErrorimgactive] = useState(false)

//   const [errorimginactive, setErrorimginactive] = useState(false)

//   const navigate = useNavigate();



  
//     useEffect(() => {

//       // setIsloading(true)

//       const uploadActiveFile = () => {
  
//         const name = new Date().getTime() + activefile.name;
        
//         const storageRef = ref(storage, "loayaltyRewardImages/"+name);
  
//         const uploadTask = uploadBytesResumable(storageRef, activefile);
  
//         uploadTask.on('state_changed', 

//           (snapshot) => {
          
//             const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//             console.log('Upload is ' + progress + '% done');
//             setPerc('Upload is ' + progress.toFixed(0) + '% complete')
//             switch (snapshot.state) {
//               case 'paused':
//                 console.log('Upload is paused');
//                 break;
//               case 'running':
//                 console.log('Upload is running');
//                 break;
//               default:
//                 break;
//             }
//           }, 
//           (error) => {
//             console.log(error)
//           }, 
//           () => {
           
//             getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//               // set((prev) => ({...prev, img: downloadURL}))
//               setImgactive(downloadURL)

//               // setIsloading(false)

//             });
//           }
//         );
  
//       };
  
//       activefile && uploadActiveFile();
  
//   }, [activefile]);



//     useEffect(() => {

//       // setIsloading(true)

//       const uploadInactiveFile = () => {
  
//         const name = new Date().getTime() + inactivefile.name;
        
//         const storageRef = ref(storage, "loayaltyRewardImages/"+name);
  
//         const uploadTask = uploadBytesResumable(storageRef, inactivefile);
  
//         uploadTask.on('state_changed', 

//           (snapshot) => {
          
//             const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//             console.log('Upload is ' + progress + '% done');
//             setPerc('Upload is ' + progress.toFixed(0) + '% complete')
//             switch (snapshot.state) {
//               case 'paused':
//                 console.log('Upload is paused');
//                 break;
//               case 'running':
//                 console.log('Upload is running');
//                 break;
//               default:
//                 break;
//             }
//           }, 
//           (error) => {
//             console.log(error)
//           }, 
//           () => {
           
//             getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//               // set((prev) => ({...prev, img: downloadURL}))
//               setImginactive(downloadURL)

//               // setIsloading(false)

//             });
//           }
//         );
  
//       };
  
//       inactivefile && uploadInactiveFile();
  
//   }, [inactivefile]);





      
//   const getReward = async() => {

//       const docRef = doc(db, "loyaltyReward", rewardId);

//       const docSnap = await getDoc(docRef);

    
      
//       if (docSnap.exists()) {

//         // setAdvertData(docSnap.data())
//         setTitle(docSnap.data().title)
//         setDescription(docSnap.data().description)
//         setCoin(docSnap.data().coin)
//         setPrice(docSnap.data().price)
//         setWidth(docSnap.data().width)
//         setHeight(docSnap.data().height)
//         setImgactive(docSnap.data().imgactive)
//         setImginactive(docSnap.data().imginactive)
    
//         // console.log(outletData)
//       } else {
//         // doc.data() will be undefined in this case
//         console.log("No such document!");
//       }
//   }



//   useEffect(()=>{

//     getReward()

//   }, [])




//   // const deleteactiveUrl = () => {

//   //       const deleteRef = ref(storage, rewardImage);
    
//   //           // Delete the file
//   //       deleteObject(deleteRef)

//   //       setImgactive("")

//   //       setactivefile("")

    
//   // }


  
//   const deleteactiveImage = () => {

//      const deleteRef = ref(storage, imgactive);
    
//             // Delete the file
//         deleteObject(deleteRef)

//         .then(async() => {
    
    
//             const delRef = doc(db, 'loyaltyReward', rewardId);
    
//             // Remove the 'capital' field from the document
//             await updateDoc(delRef, {

//                 imgactive: deleteField()

//             });

//             setImgactive("")

//             setactivefile("")

      
//         }).catch((error) => {
//             // Uh-oh, an error occurred!
//             console.log(error)
//         });
//   }



//    const deleteinactiveImage = () => {

//      const deleteRef = ref(storage, imginactive);
    
//             // Delete the file
//         deleteObject(deleteRef)

//         .then(async() => {
    
    
//             const delRef = doc(db, 'loyaltyReward', rewardId);
    
//             // Remove the 'capital' field from the document
//             await updateDoc(delRef, {

//                 imginactive: deleteField()

//             });

//             setImginactive("")

//             setinactivefile("")

      
//         }).catch((error) => {
//             // Uh-oh, an error occurred!
//             console.log(error)
//         });
//   }




//   // const deleteinactiveUrl  = () => {

//   //       const deleteRef = ref(storage, rewardImage);
    
//   //           // Delete the file
//   //       deleteObject(deleteRef)

//   //       setImginactive("")

//   //       setinactivefile("")

    
//   // }

  
    
//     const handlePoints = async(e) => {
  
//       e.preventDefault()

//       if(title === ""){
        
//         return setErrorTitle("Title is required")
//       }

//        if(description === ""){
        
//         return setErrorDescription("Description is required")
//       }

//        if(coin === ""){
        
//         return setErrorCoin("Coin is required")
//       }

//        if(price === ""){
        
//         return setErrorPrice("price is required")
//       }

//        if(width === ""){
        
//         return setErrorWidth("Width is required")
//       }

//        if(height === ""){
        
//         return setErrorHeight("Height Photo is required")
//       }

      
//       setIsloading(true)


//          try{

//           await updateDoc(doc(db, "loyaltyReward", rewardId), {
    
//             title: title,
//             description: description,
//             coin: Number(coin),
//             price: Number(price),
//             height: Number(height),
//             width: Number(width),
//             imgactive: imgactive,
//             imginactive: imginactive,
//             status: status,
//             redeemStatus: redeemStatus,
//             externalStatus: externalStatus,
//             createdAt : today,
    
//           })


//         setIsloading(false)

//         navigate("/reward")
        
//       }catch (err) {

//         console.log(err);

//       } 
  
//     }



//     const handleTitle = (e) => {

//          setTitle(e.target.value)

//          if(title !== ""){

//           setErrorTitle(false)
          
//          }

//     }

    
//     const handleDescription = (e) => {

//          setDescription(e.target.value)

//          if(description !== ""){

//           setErrorDescription(false)
          
//          }

//     }


//       const handleCoin = (e) => {

//          setCoin(e.target.value)

//          if(coin !== ""){

//           setErrorCoin(false)
          
//          }

//     }


//     const handlePrice = (e) => {

//          setPrice(e.target.value)

//          if(price !== ""){

//           setErrorPrice(false)
          
//          }

//     }


//       const handleWidth = (e) => {

//          setWidth(e.target.value)

//          if(width !== ""){

//           setErrorWidth(false)
          
//          }

//     }


//     const handleHeight = (e) => {

//          setHeight(e.target.value)

//          if(height !== ""){

//           setErrorHeight(false)
          
//          }

//     }



//   return (
//     <div className="new">
//       {/* {isloading && <Spinner />} */}
//       <Sidebar/>
//       <div className="newContainer">
//       <Navbar/>
//         <div className='top'>
//           <div className='topLeft'><h1>Edit Reward</h1></div>
          
//           <div className='topRight'>
//           <Breadcrumbs aria-label="breadcrumb">
//             <Link underline="hover" color="inherit" href="/">
//               Home
//             </Link>
//             <Link
//               underline="hover"
//               color="inherit"
//               href="/reward"
//             >
//               Reward List
//             </Link>
//             <Typography color="green">Edit Reward</Typography>
//           </Breadcrumbs>
//           </div>
//         </div>
//         <div className='bottom'>
       
//         <div className='right'>
//           <div className='form'>

//                 <div style={{display: 'flex', flexDirection:'row', width: '100%', gap:20, flexWrap:'wrap'}}>


//                     <div style={{width:'49%', flexDirection:'column'}}>

//                        <TextField
//                             type="text"
//                             name="title"
//                             placeholder="Enter Title"
//                             value={title}
//                             onChange={handleTitle}
//                             style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
//                             variant="outlined" 
//                             sx={{ "& fieldset": { border: "none" } }} 
//                           />
//                           {
//                             errorTitle &&

//                             <p style={{color:'red', fontSize:15, }}>{errorTitle}</p>

//                           }

//                     </div>

//                     <div style={{width:'49%', flexDirection:'column'}}>

//                        <TextField
//                             type="text"
//                             name="description"
//                             placeholder="Enter Description of food or drink"
//                             value={description}
//                             onChange={handleDescription}
//                             style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
//                             variant="outlined" 
//                             sx={{ "& fieldset": { border: "none" } }} 
//                           />
//                           {
//                             errorDescription &&

//                             <p style={{color:'red', fontSize:15, }}>{errorTitle}</p>

//                           }

//                     </div>

//                     <div style={{width:'49%', flexDirection:'column'}}>

//                       <TextField
//                             type="text"
//                             name="coin"
//                             placeholder="Enter Coin eg 100"
//                             value={coin}
//                             onChange={handleCoin}
//                             style={{width:'100%', backgroundColor:'#f9e3ff', width:'100%', borderWidth:0}}
//                             variant="outlined" 
//                             sx={{ "& fieldset": { border: "none" } }} 
//                       />

//                       {
//                         errorCoin &&

//                         <p style={{color:'red', fontSize:15, }}>{errorCoin}</p>

//                       }

//                     </div>

//                     <div style={{width:'49%', flexDirection:'column', position:'relative'}}>

//                         <TextField
//                           type="text"
//                           name="price"
//                           placeholder="Enter Actual Reward Price eg N5000"
//                           value={price}
//                           onChange={handlePrice}
//                           style={{width:'100%', backgroundColor:'#f9e3ff', width:'95%', borderWidth:0, paddingLeft:30, border:0}}
//                           variant="outlined" 
//                           sx={{ "& fieldset": { border: "none" } }} 
//                         />

//                         <img
//                           src="../images/naira.png"
//                           alt=""
//                           style={{position: 'absolute', width:15, height:20, left:20, top:17}}
//                           resizeMode = "contain"
//                         />

//                         {
//                           errorPrice &&

//                           <p style={{color:'red', fontSize:15, }}>{errorPrice}</p>

//                         }

//                     </div>

                  
//                     <div style={{width:'49%', flexDirection:'column'}}>

//                       <TextField
//                           type="text"
//                           name="width"
//                           placeholder="Enter Image Width eg 60"
//                           value={width}
//                           onChange={handleWidth}
//                           style={{width:'100%', backgroundColor:'#f9e3ff'}}
//                           variant="outlined" 
//                           sx={{ "& fieldset": { border: "none" } }} 
//                         />

//                         {
//                           errorWidth &&

//                           <p style={{color:'red', fontSize:15, }}>{errorWidth}</p>

//                         }

//                     </div>

//                     <div style={{width:'49%', flexDirection:'column'}}>

//                       <TextField
//                           type="text"
//                           name="height"
//                           placeholder="Enter Image height eg 80"
//                           value={height}
//                           onChange={handleHeight}
//                           style={{width:'100%', backgroundColor:'#f9e3ff'}}
//                           variant="outlined" 
//                           sx={{ "& fieldset": { border: "none" } }} 
//                         />

//                         {
//                           errorHeight &&

//                           <p style={{color:'red', fontSize:15, }}>{errorHeight}</p>

//                         }

//                     </div>

                
//                 </div>


//                 <hr style={{width:'100%', height:0, color:'$eee'}}/>


//                 <div style={{display: 'flex', width:'100%', flexDirection:'row', justifyContent:'space-between'}}>

               


//                    <div style={{display:'flex', width:'49%'}}>

//                     {

//                      ( activefile && !imgactive)
                       
//                     &&

//                       <div style={{display:'flex', width:'100%', height:200, alignItems:'center', justifyContent:'center'
//                       }}>

//                       <p style={{color:'blue', fontSize:20, fontWeight:700}}>{perc}</p>

//                       </div>

//                     }

//                     {

//                       (imgactive && activefile)
                      
//                       &&

//                       <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10, justifyContent:'center', alignItems:'center'}}>


//                       <img
//                         src={URL.createObjectURL(activefile) }
//                         alt=""
//                         // className='imgs'
//                         style={{width:160, height:200, cursor:'pointer'}}
//                         resizeMode = "contain"
//                       />

//                       <Button onClick={deleteactiveImage} style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

//                       </div>

//                       }


//                      {

//                       (imgactive && !activefile )
                      
//                       &&

//                       <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10, justifyContent:'center', alignItems:'center'}}>


//                         <img
//                         src={imgactive}
//                         alt=""
//                         // className='imgs'
//                         style={{width:160, height:200, cursor:'pointer'}}
//                         resizeMode = "contain"
//                       />

//                       <Button onClick={deleteactiveImage} style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

//                       </div>

//                       }


//                       {

//                       (!imgactive && !activefile)

//                       &&

//                       <div style={{display:'flex', width:'100%', height:200, flexDirection:'column', gap:10, alignItems:'center', justifyContent:'center', backgroundColor:'#eee'}}>
//                         <label htmlFor='activefile'>
//                         {/* < CloudUploadOutlinedIcon style={{width:100}}/> */}
//                         <img
//                         src="../images/cloud.png"
//                         alt=""
//                         style={{cursor:'pointer', width:100, height:100, marginLeft:60}}
//                         // className='imgs'
//                         resizeMode = "contain"
//                       />

//                        <p style={{fontSize:18, fontWeight:500, color:'#309ff4ff', cursor:'pointer'}}>Tap to upload active Loyalty Reward Image</p>
//                         </label>
                       
//                          {/* <p style={{fontSize:18, fontWeight:500, color:'#4c4b4bff'}}>Landscape design with dimension (width:500px by height:250px)</p> */}
//                         <input type="file" id="activefile" onChange= {e => setactivefile(e.target.files[0])} style={{display:'none'}}/>
//                       </div>



//                       }

                      
//                   </div>


//                   <div style={{display:'flex', width:'49%'}}>

//                     {

//                      ( inactivefile && !imginactive)
                       
//                     &&

//                       <div style={{display:'flex', width:'100%', height:200, alignItems:'center', justifyContent:'center'
//                       }}>

//                       <p style={{color:'blue', fontSize:20, fontWeight:700}}>{perc}</p>

//                       </div>

//                     }

//                     {

//                       (imginactive && inactivefile)
                      
//                       &&

//                       <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10, justifyContent:'center', alignItems:'center'}}>

//                       <img
//                         src={URL.createObjectURL(inactivefile) }
//                         alt=""
//                         // className='imgs'
//                         style={{width:160, height:200, cursor:'pointer'}}
//                         resizeMode = "contain"
//                       />

//                       <Button onClick={deleteinactiveImage } style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

//                       </div>

//                       }


//                          {

//                       (imginactive && !inactivefile )
                      
//                       &&

//                       <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10, justifyContent:'center', alignItems:'center'}}>


//                         <img
//                         src={imginactive}
//                         alt=""
//                         // className='imgs'
//                         style={{width:160, height:200, cursor:'pointer'}}
//                         resizeMode = "contain"
//                       />

//                       <Button onClick={deleteinactiveImage} style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

//                       </div>

//                       }


//                       {

//                       (!imginactive && !inactivefile)

//                       &&

//                       <div style={{display:'flex', width:'100%', height:200, flexDirection:'column', gap:10, alignItems:'center', justifyContent:'center', backgroundColor:'#eee'}}>
//                         <label htmlFor='inactivefile'>
//                         {/* < CloudUploadOutlinedIcon style={{width:100}}/> */}
//                         <img
//                         src="../images/cloudinactive.png"
//                         alt=""
//                         style={{cursor:'pointer', width:100, height:100, marginLeft:60}}
//                         // className='imgs'
//                         resizeMode = "contain"
//                       />

//                        <p style={{fontSize:18, fontWeight:500, color:'#309ff4ff', cursor:'pointer'}}>Tap to upload Inactive Loyalty Reward Image</p>
//                         </label>
                       
//                          {/* <p style={{fontSize:18, fontWeight:500, color:'#4c4b4bff'}}>Landscape design with dimension (width:500px by height:250px)</p> */}
//                         <input type="file" id="inactivefile" onChange= {e => setinactivefile(e.target.files[0])} style={{display:'none'}}/>
//                       </div>

//                       }

                      
//                   </div>


//                 </div>


//                 <hr style={{width:'100%', height:0, color:'$eee'}}/>

//                   <Button 
                  
//                     onClick={handlePoints} 
//                     disabled={perc !== null && perc < 100}
//                     style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>
//                     {isloading ? '...loading' : 'Upload Loyalty Reward'}
                    
//                   </Button>


               


//           </div>
//         </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Edit



// import './edit.scss'
// import Sidebar from '../../../components/sidebar/Sidebar'
// import Navbar from '../../../components/navbar/Navbar'
// import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
// import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
// import {serverTimestamp, setDoc, doc, collection, query, where, writeBatch, onSnapshot, addDoc, updateDoc, deleteField, getDoc } from "firebase/firestore";
// import { auth, db, storage, messaging } from "../../../firebase";
// import { createUserWithEmailAndPassword } from 'firebase/auth';
// import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
// import Typography from '@mui/material/Typography';
// import Breadcrumbs from '@mui/material/Breadcrumbs';
// import Link from '@mui/material/Link';
// import { useNavigate, useParams } from "react-router-dom"
// import { TextField, Button } from '@mui/material';
// import Divider from '@mui/material/Divider';

// import Box from '@mui/material/Box';

// // import { Editor } from "@tinymce/tinymce-react";


// const Edit = () => {

//   const {advertId} = useParams()

//   const [isloading, setIsloading ] = useState(false)

//   const today = new Date().toDateString()

//   const [advertData, setAdvertData] = useState("")

//   const [title, setTitle] = useState("")

//   const [description, setDescription] = useState("")

//   const [brandname, setBrandname] = useState("")

//   const [brandaddress, setBrandaddress] = useState("")

//   const [brandtelephone, setBrandTelephone]= useState("")

//   const [brandsocials, setBrandsocials] = useState("")
  
//   const [ perc, setPerc ] = useState(null)
  
//   const [file, setFile ] = useState("")

//   const [advertImage, setAdvertImage] = useState("")

//   const [viewCount, SetViewCount] = useState(0)

//   const [likeCount, setLikeCount] = useState(0)

//   const [messageCount, setMessageCount] = useState(0)

//   const [brandstatus, setBrandstatus] = useState('active')

//   const [errorTitle, setErrorTitle] = useState(false)

//   const [errorDescription, setErrorDescription] = useState(false)

//   const [errorBrandname, setErrorBrandname] = useState(false)

//   const [errorBrandaddress, setErrorBrandaddress] = useState(false)

//   const [errorBrandtelephone, setErrorBrandtelephone] = useState(false)

//   const [errorBrandsocials, setErrorBrandsocials] = useState(false)

//   const [errorfile, setErrorFile] = useState(false)

//   const navigate = useNavigate();



  
//     useEffect(() => {

//       // setIsloading(true)

//       const uploadFile = () => {
  
//         const name = new Date().getTime() + file.name;
        
//         const storageRef = ref(storage, "advertImages/"+name);
  
//         const uploadTask = uploadBytesResumable(storageRef, file);
  
//         uploadTask.on('state_changed', 
//           (snapshot) => {
          
//             const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//             console.log('Upload is ' + progress + '% done');
//             setPerc('Upload is ' + progress.toFixed(0) + '% complete')
//             switch (snapshot.state) {
//               case 'paused':
//                 console.log('Upload is paused');
//                 break;
//               case 'running':
//                 console.log('Upload is running');
//                 break;
//               default:
//                 break;
//             }
//           }, 
//           (error) => {
//             console.log(error)
//           }, 
//           () => {
           
//             getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//               // set((prev) => ({...prev, img: downloadURL}))
//               setAdvertImage(downloadURL)

//               // setFile("")

//               // setIsloading(false)

//             });
//           }
//         );
  
//       };
  
//       file && uploadFile();
  
//   }, [file]);




    
//   const getAdvert = async() => {

//       const docRef = doc(db, "adverts", advertId);

//       const docSnap = await getDoc(docRef);

    
      
//       if (docSnap.exists()) {

//         // setAdvertData(docSnap.data())
//         setTitle(docSnap.data().title)
//         setDescription(docSnap.data().description)
//         setBrandname(docSnap.data().brandname)
//         setBrandaddress(docSnap.data().brandaddress)
//         setBrandTelephone(docSnap.data().brandtelephone)
//         setBrandsocials(docSnap.data().brandsocials)
//         setAdvertImage(docSnap.data().advertImage)
//         setBrandstatus(docSnap.data().status)
    
//         // console.log(outletData)
//       } else {
//         // doc.data() will be undefined in this case
//         console.log("No such document!");
//       }
//   }



//   useEffect(()=>{

//     getAdvert()

//   }, [])




//   const deleteUrl = () => {

//         const deleteRef = ref(storage, advertImage);
    
//             // Delete the file
//         deleteObject(deleteRef)
        
    
    
//   }


//   const deleteUrlImage = () => {

//      const deleteRef = ref(storage, advertImage);
    
//             // Delete the file
//         deleteObject(deleteRef)

//         .then(async() => {
    
    
//             const adRef = doc(db, 'adverts', advertId);
    
//             // Remove the 'capital' field from the document
//             await updateDoc(adRef, {

//                 advertImage: deleteField()

//             });

//             setAdvertImage("")

//             setFile("")

      
//         }).catch((error) => {
//             // Uh-oh, an error occurred!
//             console.log(error)
//         });
//   }

  
    
//     const handleAdverts = async(e) => {
  
//       e.preventDefault()

//       if(title === ""){
        
//         return setErrorTitle("Title is required")
//       }

//        if(description === ""){
        
//         return setErrorDescription("Description is required")
//       }

//        if(brandname === ""){
        
//         return setErrorBrandname("Brand name is required")
//       }

//        if(brandaddress === ""){
        
//         return setErrorBrandaddress("Brand Address is required")
//       }

//        if(brandtelephone === ""){
        
//         return setErrorBrandtelephone("Brand Telephone is required")
//       }

//        if( advertImage === ""){
        
//         return setErrorFile("Brand Photo is required")
//       }

      


//       setIsloading(true)
  
//       try{

//           await updateDoc(doc(db, "adverts", advertId), {
    
//               title: title,
//               description: description,
//               datePublished: today,
//               advertImage: advertImage,
//               brandname: brandname,
//               brandaddress: brandaddress,
//               brandtelephone: brandtelephone,
//               brandsocials: brandsocials,
//               status : brandstatus,
//               timeStamp: serverTimestamp(),

    
//           })


//         setIsloading(false)

//         navigate("/adverts")
        
//       }catch (err) {

//         console.log(err);

//       } 
  
//     }

//     const handleTitle = (e) => {

//          setTitle(e.target.value)

//          if(title !== ""){

//           setErrorTitle(false)
          
//          }

//     }


//       const handleDescription = (e) => {

//          setDescription(e.target.value)

//          if(description !== ""){

//           setErrorDescription(false)
          
//          }

//     }

//     const handleBrandname = (e) => {

//          setBrandname(e.target.value)

//          if(brandname !== ""){

//           setErrorBrandname(false)
          
//          }

//     }

//       const handleBrandaddress = (e) => {

//          setBrandaddress(e.target.value)

//          if(brandname !== ""){

//           setErrorBrandaddress(false)
          
//          }

//     }


//     const handleBrandTelephone = (e) => {

//          setBrandTelephone(e.target.value)

//          if(brandtelephone !== ""){

//           setErrorBrandtelephone(false)
          
//          }

//     }


//      const handleBrandSocials = (e) => {

//          setBrandsocials(e.target.value)

//          if(brandsocials !== ""){

//           setErrorBrandsocials(false)
          
//          }

//     }



//   return (
//     <div className="new">
//       {/* {isloading && <Spinner />} */}
//       <Sidebar/>
//       <div className="newContainer">
//       <Navbar/>
//         <div className='top'>
//           <div className='topLeft'><h1>New Advert</h1></div>
          
//           <div className='topRight'>
//           <Breadcrumbs aria-label="breadcrumb">
//             <Link underline="hover" color="inherit" href="/">
//               Home
//             </Link>
//             <Link
//               underline="hover"
//               color="inherit"
//               href="/adverts"
//             >
//               Advert List
//             </Link>
//             <Typography color="green">New Advert</Typography>
//           </Breadcrumbs>
//           </div>
//         </div>
//         <div className='bottom'>
       
//         <div className='right'>
//           <div className='form'>

//                 <div style={{display: 'flex', flexDirection:'column', width: '100%', gap:20}}>
                
//                   <TextField
//                     type="text"
//                     name="title"
//                     placeholder="Enter Advert Title"
//                     value={title}
//                     onChange={handleTitle}
//                     style={{width:'100%', backgroundColor:'#f9e3ff'}}
//                   />
//                   {
//                     errorTitle &&

//                     <p style={{color:'red', fontSize:15, }}>{errorTitle}</p>

//                   }
//                   <TextField
//                     type="text"
//                     name="Description"
//                     placeholder="Enter Advert Description"
//                     value={description}
//                     multiline
//                     minRows={3}
//                     maxRows={10}
//                     onChange={handleDescription}
//                     style={{width:'100%', backgroundColor:'#f9e3ff'}}
//                   />

//                    {
//                     errorDescription &&

//                     <p style={{color:'red', fontSize:15, }}>{errorDescription}</p>

//                   }

//                   <TextField
//                     type="text"
//                     name="brandname"
//                     placeholder="Enter Brand Name"
//                     value={brandname}
//                     onChange={handleBrandname}
//                     style={{width:'100%', backgroundColor:'#f9e3ff'}}
//                   />

//                    {
//                     errorBrandname &&

//                     <p style={{color:'red', fontSize:15, }}>{errorBrandname}</p>

//                   }

//                   <TextField
//                     type="text"
//                     name="brandaddress"
//                     placeholder="Enter Brand Address"
//                     value={brandaddress}
//                     onChange={handleBrandaddress}
//                     style={{width:'100%', backgroundColor:'#f9e3ff'}}
//                   />

//                    {
//                     errorBrandaddress &&

//                     <p style={{color:'red', fontSize:15, }}>{errorBrandaddress}</p>

//                   }

//                   <TextField
//                     type="text"
//                     name="brandtelephone"
//                     placeholder="Enter Telephone"
//                     value={brandtelephone}
//                     onChange={handleBrandTelephone}
//                     style={{width:'100%', backgroundColor:'#f9e3ff'}}
//                   />

//                    {
//                     errorBrandtelephone &&

//                     <p style={{color:'red', fontSize:15, }}>{errorBrandtelephone}</p>

//                   }

//                     <TextField
//                     type="text"
//                     name="brandsocails"
//                     placeholder="Enter Brand Social Media or Website"
//                     value={brandsocials}
//                     onChange={handleBrandSocials}
//                     style={{width:'100%', backgroundColor:'#f9e3ff'}}
//                   />

//                  {
//                     errorBrandsocials &&

//                     <p style={{color:'red', fontSize:15, }}>{errorBrandsocials}</p>

//                   }
            
                
//                 </div>


//                 <hr style={{width:'100%', height:1, color:'$eee'}}/>


//                    <div style={{display:'flex', width:'100%'}}>

//                     {

//                      ( file && !advertImage)
                       
//                     &&

//                       <div style={{display:'flex', width:'100%', height:200, alignItems:'center', justifyContent:'center'
//                       }}>

//                       <p style={{color:'blue', fontSize:20, fontWeight:700}}>{perc}</p>

//                       </div>

//                     }

//                     {

//                       (file && advertImage )
                      
//                       &&

//                       <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10}}>


//                         <img
//                         src={ URL.createObjectURL(file)}
//                         alt=""
//                         // className='imgs'
//                         style={{width:'100%', height:'80%', cursor:'pointer'}}
//                         resizeMode = "contain"
//                       />

//                       <Button onClick={deleteUrl} style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

//                       </div>

//                       }


//                       {

//                       (advertImage && !file )
                      
//                       &&

//                       <div style={{display:'flex', width:'100%', flexDirection:'column', gap:10}}>


//                         <img
//                         src={advertImage}
//                         alt=""
//                         // className='imgs'
//                         style={{width:'100%', height:'80%', cursor:'pointer'}}
//                         resizeMode = "contain"
//                       />

//                       <Button onClick={deleteUrlImage} style={{width:'50%',height:60,  backgroundColor:'rgba(246, 109, 91, 1)', color:'#eee'}}>Change Photo</Button>

//                       </div>

//                       }


//                       {

//                       ( !file && !advertImage)

//                         &&


//                        <div style={{display:'flex', width:'100%', height:200, flexDirection:'column', gap:10, alignItems:'center', justifyContent:'center', backgroundColor:'#eee'}}>
//                         <label htmlFor='file'>
//                         {/* < CloudUploadOutlinedIcon style={{width:100}}/> */}
//                         <img
//                         src="../images/cloud.png"
//                         alt=""
//                         style={{cursor:'pointer', width:100, height:100, marginLeft:60}}
//                         // className='imgs'
//                         resizeMode = "contain"
//                       />

//                        <p style={{fontSize:18, fontWeight:500, color:'#309ff4ff', cursor:'pointer'}}>Tap to upload Advert Image</p>
//                         </label>
                       
//                          <p style={{fontSize:18, fontWeight:500, color:'#4c4b4bff'}}>Landscape design with dimension (width:500px by height:250px)</p>
//                         <input type="file" id="file" onChange= {e => setFile(e.target.files[0])} style={{display:'none'}}/>
//                       </div>



//                       }

                      
//                   </div>

//                   {
//                     errorfile &&

//                     <p style={{color:'red', fontSize:15, }}>{errorfile}</p>

//                   }
                  


//                 <hr style={{width:'100%', height:1, color:'$eee'}}/>

//                   <Button 
                  
//                     onClick={handleAdverts} 
//                     disabled={perc !== null && perc < 100}
//                     style={{width:'100%',height:60,  backgroundColor:'rgb(15, 31, 175)'}}>
//                     {isloading ? '...loading' : 'Advert'}
                    
//                   </Button>


               


//           </div>
//         </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Edit


// import './edit.scss'
// import Sidebar from '../../../components/sidebar/Sidebar'
// import Navbar from '../../../components/navbar/Navbar'
// // import Chart from '../../../components/chart/Chart'
// import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc, serverTimestamp, arrayRemove } from "firebase/firestore"
// import {  Link, useNavigate, useParams } from "react-router-dom"
// import { db, storage } from '../../../firebase'
// import { Box, Breadcrumbs, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, OutlinedInput, Chip } from '@mui/material'
// // import { useTheme } from '@mui/material/styled';
// import { useTheme } from '@material-ui/core/styles';
// import { allRegions, allAreas, allOutlets, openList } from '../../../data/dataSource'
// import { deleteObject, ref } from 'firebase/storage'



// const ITEM_HEIGHT = 48;
// const ITEM_PADDING_TOP = 8;
// const MenuProps = {
//   PaperProps: {
//     style: {
//       maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//       // width: 250,
//     },
//   },
// };




// const outletAmenities = [
//     {key:'1', value:'Free Wifi'},
//     {key:'2', value:'Car Wash'},
//     {key:'3', value:'Swimming Pool'},
//     {key:'4', value:'Pool Bar',},
//     {key:'5', value:'Live Music'},
//     {key:'6', value:'Parking Space'},
//     {key:'7', value:'Smart TVs'},
//     {key:'8', value:'Secured Environment'},
//     {key:'9', value:'Gym/Fitness Centre'},
//     {key:'10', value:'Laundry Services'},
//     {key:'11', value:'Complimentary Breakfast'},
//     {key:'12', value:'Spa/Wellness Services'},
//     {key:'13', value:'Airport Pick-up'},
//     {key:'14', value:'VIP Space'},
//     {key:'15', value:'Enhance Hygiene'},
//     {key:'16', value:'Cozy Serenity'},
//     {key:'17', value:'Board & Outdoor Games'},
//     {key:'18', value:'Meeting & Event Spaces',},
//     {key:'19', value:'Smart Rooms'},
//     {key:'20', value:'Pet Friendly'},
//     {key:'21', value:'Virtual Reality Experience'},
//     {key:'22', value:'Beauty treatment & Salon services'},
//     {key:'23', value:'Private Security & Escort Services'},
//     {key:'24', value:'Movie Theatre'},
//     {key:'25', value:'Private Masseurs'},
//     {key:'26', value:'Adventure Park'},
//     {key:'27', value:'Boutique',},
//     {key:'28', value:'Mini sport court'},
//     {key:'29', value:'Outdoor Patio'},
//     {key:'30', value:'Work Station'},

// ]




// const Edit = ({user}) => {

//   const {outletId} = useParams()


//   const [ outletData, setOutletData ] = useState([])


//   const [ region, setRegion ] = useState("")

//   const [ area, setArea ] = useState("")
  
//   const [ category, setCategory ] = useState("")

//   const [outletname, setOutletname] = useState("")

//   const [address, setAddress] = useState("")

//   const [amenities, setAmenities] = useState([]);

//   const [description, setDescription] = useState("")

//   const [open, setOpen ] = useState("")

//   const [telephone, setTelephone] = useState("")

//   const [whatsapp, setWhatsapp] = useState("")

//   const [subscriberID, setSubscriberID] = useState("")

//   const [ agentCode, setAgentCode] = useState("")

//   const [ review, setReview] = useState([])

//   const [photos, setPhotos] = useState([])
 
//   const [ openModal, setOpenModal ] = useState(false)

//   const closeModal = () => setOpenModal(false)

//   const [openStatus, setOpenStatus] = useState(false)

//   const [isloading, setIsloading] = useState(false)

//   const [areaList, setAreaList] = useState([])

//   const [categoryList, setCategoryList] = useState([])

//   const [searchList, setSearchList] = useState([])

//   const [resetKeyRegion, setResetKeyRegion] = useState(0);

//   const [resetKeyArea, setResetKeyArea] = useState(0);

//   const [resetKeyCategory, setResetKeyCategory] = useState(0);

//   const [counter, setCounter] = useState(0);

//   const [filesLength, setFilesLength] = useState(0)

//   const theme = useTheme();

//   const [errorCategory, setErrorCategory] = useState("")

//   const [errorOutletname, setErrorOutletname] = useState("")

//   const [errorAddress, setErrorAddress] = useState("")

//   const [errorRegion, setErrorRegion] = useState("")

//   const [errorArea, setErrorArea] = useState("")

//   const [errorAmenity, setErrorAmenity] = useState("")

//   const [errorDescription, setErrorDescription] = useState("")

//   const [errorOpen, setErrorOpen] = useState("")

//   const [errorTelephone, setErrorTelephone] = useState("")

//   const [errorWhatsapp, setErrorWhatsapp] = useState("")

  
// function getStyles(amenity, amenities, useTheme) {
//   return {
//     fontWeight: amenity.includes(amenity)
//       ? theme.typography.fontWeightMedium
//       : theme.typography.fontWeightRegular,
//   };
// }


// const navigate = useNavigate()

//   // const handleChange = (event) => {
//   //   setChecked(event.target.checked);
//   // };

//   const Spinner = () => {
//     return(
//       <span className='spinner-container'>
//           <span className='loading-spinner'></span>
//       </span>
//     )
//   }

//     const handleChange = (event) => {
//     const {
//       target: { value },
//     } = event;
//     setAmenities(
//       // On autofill we get a stringified value.
//       typeof value === 'string' ? value.split(',') : value,
//     );
//   };


//     const decrementCounter = () => {
//         setCounter(counter - 1);
//     };

//      const deleteUrl = async(i) => {

        
//             const deleteRef = ref(storage, i);
    
//             deleteObject(deleteRef).then(async() => {
           
//                 const photoRef = doc(db, "subscribers", outletId);
    
//                 await updateDoc(photoRef, {

//                     files: arrayRemove(i)
//                 });
    
//                 decrementCounter()
        
                
//                 alert("Photo removed")
        
        
//             }).catch((error) => {

//                 console.log(error)

//             });
        
//     }
    
    
//  useEffect(() => {

//      if(region){

//         setAreaList(allAreas[region] || []);
    
//      } else {

//         setAreaList([]);

//         setArea(null)

//     }


//  }, [region])

 


//   useEffect(() => {

    
//      if(area){

//       setCategoryList(allOutlets[area] || []);

//      }else {
     
//       setCategoryList([]);

//       setCategory(null);
//     }


//  }, [area])


//   // const handleChangecategory = (event) => {

//   //   setCategory(event.target.value);
  
//   // };

//    const handleChangeRegion = (event) => {

//      setRegion(event.target.value);

//       setArea("");

//       setCategory("");


//       setResetKeyArea(prevKey => prevKey + 1);

//       setResetKeyCategory(prevKey => prevKey + 1);
//       // setOutletList([]);

//       if (event.target.value) {


//         setAreaList(allAreas[event.target.value] || []);

//       } else {

//         setAreaList([]);

//       }


//       // setAreaList(allAreas[region] || []);

  
//   };




//   const handleChangeArea = (event) => {

//       setArea(event.target.value);

//       setCategory("");


//       setResetKeyCategory(prevKey => prevKey + 1);
//       // setOutletList([]);

//       if (event.target.value) {


//         setCategoryList(allOutlets[event.target.value] || []);

//       } else {

//         setCategoryList([]);

//       }

//   } 



//    const handleChangecategory = (event) => {

//       setCategory(event.target.value);      
  
//   } 

 
  

  
//   const getAdvert = async() => {

//       const docRef = doc(db, "adverts", outletId);

//       const docSnap = await getDoc(docRef);

    
      
//       if (docSnap.exists()) {

//         setOutletData(docSnap.data())
//         setCategory(docSnap.data().outlet)
//         setRegion(docSnap.data().region)
//         setArea(docSnap.data().area)
//         setOutletname(docSnap.data().outletname)
//         setAddress(docSnap.data().address)
//         setAmenities(docSnap.data().amenity)
//         setDescription(docSnap.data().description)
//         setOpen(docSnap.data().open)
//         setSubscriberID(docSnap.data().subscriberID)
//         setTelephone(docSnap.data().telephone)
//         setWhatsapp(docSnap.data().whatsapp)
//         setAgentCode(docSnap.data().agentCode)
//         setFilesLength(docSnap.data().files.length)
//         setCounter(docSnap.data().counter)
//         // console.log(outletData)
//       } else {
//         // doc.data() will be undefined in this case
//         console.log("No such document!");
//       }
//   }



//   useEffect(()=>{

//     getAdvert()

//   }, [])



//    useEffect(() => {
    
//         const unsub = onSnapshot(doc(db, "subscribers", outletId), (doc) => {
    
            
//             setPhotos(doc.data().files)
            
    
//         });
    
//         return () => unsub()
    
    
    
//     }, [photos])





//      const handleStatus = async() => {
    
        
//         const outletRef = doc(db, "subscribers", outletId);
    
//         await updateDoc(outletRef, {
    
//         status: outletData.status === "active" ? 'inactive' : 'active', 
    
//      })
    
//       setOpenStatus(false)
    
//       }



//       const handleUpdateOutlet = async() => {

//         if (category === "") {
//             return setErrorCategory("This field is important")
            
//         }

//         if (amenities === "") {
//             return setErrorAmenity("This field is important")
            
//         }

//         if (outletname === "") {
//             return setErrorOutletname("This field is important")
            
//         }

//         if (region === "") {
//             return setErrorRegion("This field is important")
            
//         }

//         if (area === "") {
//             return setErrorArea("This field is important")
            
//         }

//         if (address === "") {
//             return setErrorAddress("This field is important")
            
//         }

//         if (open === "") {
//             return setErrorOpen("This field is important")
            
//         }

//         if (description === "") {
//             return setErrorDescription("This field is important")
            
//         }

//         if (telephone === "") {
//             return setErrorTelephone("This field is important")
            
//         }

//         if (whatsapp === "") {
//             return setErrorWhatsapp("This field is important")
            
//         }

//         setIsloading(true)

//         try {
    
//             // const docRef = await addDoc(collection(db, "subscribers"), {
//             await updateDoc(doc(db, "subscribers", outletId), {
    
//               outlet : category,
    
//               amenity : amenities,
    
//               outletname : outletname,
    
//               region : region,
    
//               area : area,

//               address : address,
    
//               open : open,
    
//               description : description,
    
//               telephone : telephone,

//               whatsapp : whatsapp,

//               agentCode : agentCode,
    
//               subscriberID : subscriberID, 

//               // status : status,

//               // files : files,

//               // amount : amount,  

//               timeStamp: serverTimestamp(),
    
//             })


//            setIsloading(false)

//            navigate('/outlets')

                     
//         } catch (error) {
    
//           console.log(error.message);

//           setIsloading(false)

//         }
    
    
       
//       }
 

//   return (
//     <div className='single'>
//       {/* <Modal open={openModal} close={closeModal} /> */}
//       <Sidebar/>
//       <div className='singleContainer'>
//         <Navbar/>
//         <div className="top">
//           <div className="left">
//             <div style={{display: 'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between', paddingRight:50}}>
//             <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Edit  {outletData.outletname} {outletData.outlet}</h2>

//               <div className='topRight'>
//               <Breadcrumbs aria-label="breadcrumb">
//                 <Link underline="hover" color="inherit" href="/">
//                   Home
//                 </Link>
//                 <Link
//                   underline="hover"
//                   color="inherit"
//                   href="/outlets"
//                 >
//                   Outlet List
//                 </Link>
//                 <Typography color="green">Edit Outlet</Typography>
//               </Breadcrumbs>
//               </div>

//             </div>

           



//             {/* <div className='item'>
//             <img
//                 src = {outletData.files}
//                 alt="avatar"
//                 style={{width:'200px', height:'200px', borderRadius:'50%'}}
                   
//             /> 
              
//                 <div className="details">
//                   <div className='detailItem'>
//                     <span className='itemKey'>Subscriber ID:</span>
//                     <span className='itemValue'>{outletData.subscriberID}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Outlet Name:</span>
//                     <span className='itemValue'>{outletData.outletname}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Outlet:</span>
//                     <span className='itemValue'>{outletData.outlet}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Region:</span>
//                     <span className='itemValue'>{outletData.region}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Area:</span>
//                     <span className='itemValue'>{outletData.area}</span>
//                   </div>
//                 </div>


//                 <div className="details">
//                   <div className='detailItem'>
//                     <span className='itemKey'>Address:</span>
//                     <span className='itemValue'>{outletData.address_short}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Full Address:</span>
//                     <span className='itemValue'>{outletData.address}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Outlet Telephone:</span>
//                     <span className='itemValue'>{outletData.telephone}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Outlet Whatsapp Number:</span>
//                     <span className='itemValue'>{outletData.whatsapp}</span>
//                   </div>

//                   <div className='detailItem'>
//                     <span className='itemKey'>Outlet Creation Date:</span>
//                     <span className='itemValue'>{outletData.date}</span>
//                   </div>
                 
//                 </div>



//                 <div className="details">
//                   <div className='detailItem'>
//                     <span className='itemKey'>Subscription Plan:</span>
//                     <span className='itemValue'>{outletData.subscriberPlan}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Subscription Amount:</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Payment Reference:</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Outlet Open Hour:</span>
//                     <span className='itemValue'>{outletData.open}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Outlet Creation Date:</span>
//                     <span className='itemValue'>{outletData.date}</span>
//                   </div>
                 
//                 </div>

              

//             </div> */}
//           </div>
       
//         </div>
//         <div className="top">
//           <div className="left">
//             {/* <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Subscriber(Owner) Details</h2> */}

//               <div className='form'>
            
//                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>
                 
//                   <Box sx={{ minWidth: '47%' }} >
//                     <FormControl fullWidth>
//                     <InputLabel id="region" style={{color:'#999', fontWeight:300}}>Select An Outlet City</InputLabel>
//                     <Select
//                       labelId="region"
//                       id="region"
//                       value={region}
//                       key={resetKeyRegion}
//                       label="Region"
//                       onChange={handleChangeRegion}
//                       // onChange={(e) => setRegion(e.target.value)}
//                     >
//                       {allRegions.map((item) => { 

//                         return(

//                           <MenuItem key={item.key} value={item.value}>
//                             {item.value}
//                           </MenuItem>

//                         ) 
//                       })} 

//                     </Select>
//                     </FormControl>
//                   </Box>

//                    {errorRegion &&
//                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorRegion}</p>
//                    }

//                    </div>

//                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

//                    <Box sx={{ minWidth: '47%' }} >
//                     <FormControl fullWidth>
//                     <InputLabel id="area" style={{color:'#999', fontWeight:300}}>Select An Outlet Area</InputLabel>
//                     <Select
//                       labelId="area"
//                       id="area"
//                       value={area}
//                       key={resetKeyArea}
//                       label="area"
//                       onChange={handleChangeArea}
//                       // onChange={change}
                   
//                     >

//                       {areaList.map((item) => { 

//                         return(

//                           <MenuItem key={item.key} value={item.value}>
//                             {item.value}
//                           </MenuItem>

//                         ) 
//                       })}

//                     </Select>
//                     </FormControl>
//                   </Box>

//                    {errorArea &&
//                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorArea}</p>
//                    }

//                    </div>



//                         <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

//                     <Box sx={{ minWidth: '47%' }} >
//                     <FormControl fullWidth>
//                     <InputLabel id="category" style={{color:'#999', fontWeight:300,}}>Select A Category</InputLabel>
//                     <Select
//                       labelId="category"
//                       id="category"
//                       value={category}
//                       key={resetKeyCategory}
//                       label=""
//                       onChange={handleChangecategory}                     
//                     >

//                       {categoryList.map((item) => { 

//                         return(

//                           <MenuItem key={item.key} value={item.value}>{item.value}</MenuItem>

//                         ) 
//                       })}

//                     </Select>
//                     </FormControl>
//                   </Box>
//                    {errorCategory &&
//                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorCategory}</p>
//                    }

//                   </div>

                  

//                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

//                     <TextField
//                     id="outletname"
//                     onChange={(e) => setOutletname(e.target.value)}
//                     value = {outletname}
//                     placeholder="What is Your Outlet Name"
//                     style={{width:'100%'}}


//                   />

//                   {errorOutletname &&
//                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorOutletname}</p>
//                   }

//                    </div>

                 
                

//                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

//                     <TextField
//                     id="address"
//                     onChange={(e) => setAddress(e.target.value)}
//                     value = {address}
//                     placeholder="Enter Your Outlet Address"
//                     style={{width:'100%'}}

//                   />

//                    {errorAddress &&
//                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorAddress}</p>
//                    }

//                   </div>

                

//                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

//                      <FormControl sx={{ m: 1, width: '100%' }}>
//                     <InputLabel id="amenity">Select Outlet Amenities</InputLabel>
//                     <Select
//                       labelId="amenity"
//                       id="amenity-chip"
//                       multiple
//                       value={amenities}
//                       onChange={handleChange}
//                       input={<OutlinedInput id="amenity" label="Amenity" />}
//                       renderValue={(selected) => (
//                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                           {selected.map((value) => (
//                             <Chip key={value} label={value} />
//                           ))}
//                         </Box>
//                       )}
//                       MenuProps={MenuProps}
//                     >
//                       {outletAmenities.map((item) => (
//                         <MenuItem
//                           key={item.key}
//                           value={item.value}
//                           style={getStyles(item.value, amenities, theme)}
//                         >
//                           {item.value}
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>

//                    {errorAmenity &&
//                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorAmenity}</p>
//                    }

//                    </div>

                 
                    

//                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>
                    
//                     <TextField
//                     id="description" 
//                     value={description}
//                     multiline
//                     minRows={3}
//                     maxRows={10}
//                     placeholder="Enter Message"
//                     style={{width:'100%'}}
//                     onChange={(e) => setDescription(e.target.value)}
//                   />

//                    {errorDescription &&
//                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorDescription}</p>
//                    }
                    
//                   </div> 

                


//                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

//                    <Box sx={{ minWidth: '100%' }}>
//                     <FormControl fullWidth>
//                     <InputLabel id="open" style={{color:'#999', fontWeight:300}}>Select Your Outlet Work Hour</InputLabel>
//                     <Select
//                       labelId="open"
//                       id="open"
//                       value={open}
//                       label="open"
//                       onChange={(e) => setOpen(e.target.value)}
                
//                     >

                 

//                     {openList.map((item) => { 

//                         return(

//                           <MenuItem key={item.key} value={item.value}>
                            
//                             <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center', gap:40}}>
//                                 {item.value}
//                                 <div style={{width:20, height:20, backgroundColor:item.code}}></div>
//                             </div>
//                           </MenuItem>

//                         ) 
//                       })} 

//                     </Select>
//                     </FormControl>
//                   </Box>

//                     {errorOpen &&
//                     <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorOpen}</p>
//                     }

//                    </div>
                  
                  

//                     <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>
//                     <TextField
//                     id="telephone"
//                     onChange={(e) => setTelephone(e.target.value)}
//                     value = {telephone}
//                     placeholder="Enter Your Outlet Telephone"
//                     style={{width:'100%'}}
//                   />

//                    {errorTelephone &&
//                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorTelephone}</p>
//                    }

//                     </div>

                

//                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

                   
//                   <TextField
//                     id="whatsApp"
//                     onChange={(e) => setWhatsapp(e.target.value)}
//                     value = {whatsapp}
//                     placeholder="Enter Your Outlet WhatsApp Number"
//                     style={{width:'100%'}}

//                   />

//                    {errorWhatsapp &&
//                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {errorWhatsapp}</p>
//                    }

//                    </div>


//                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

//                     <TextField
//                     id="agentCode"
//                     onChange={(e) => setAgentCode(e.target.value)}
//                     value = {agentCode}
//                     placeholder="Enter Your Outlet Agent Code"
//                     style={{width:'100%'}}
//                   />


//                    </div>

                 

//                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%'}}>

//                     <TextField
//                     id="subscriberID"
//                     onChange={(e) => setSubscriberID(e.target.value)}
//                     value = {subscriberID}
//                     placeholder="Enter Your Outlet ID"
//                     style={{width:'100%'}}
//                     disabled

//                   />

//                   </div>

                


//               <Button 
//               onClick={handleUpdateOutlet} 
//               style={{width:'96%', backgroundColor:'rgb(15, 31, 175)', paddingTop:20, paddingBottom:20}}>{isloading ? <Spinner/>: 'Update Outlet'}
//               </Button>

//             </div>
//             <div className='item'>
//             {/* <img
//                 src = {outletData.userImage}
//                 alt="avatar"
//                 style={{width:'100px', height:'100px', borderRadius:'50%', marginTop:20}}
                   
//             />  */}
              
//                 {/* <div className="details">
//                   <div className='detailItem'>
//                     <span className='itemKey'>Customer ID:</span>
//                     <span className='itemValue'>{outletData.userCustomerId}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Firstname:</span>
//                     <span className='itemValue'>{outletData.userFirstname}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Lastname:</span>
//                     <span className='itemValue'>{outletData.userLastname}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Gender:</span>
//                     <span className='itemValue'>{outletData.userGender}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Age Range:</span>
//                     <span className='itemValue'>
//                       {
//                       outletData.ageRange === "firstagerange"
//                       ?
//                       "18 to 29"
//                       :
//                       outletData.ageRange === "secondagerange"
//                       ?
//                       "30 to 39"
//                       :
//                       outletData.ageRange === "thirdagerange"
//                       ?
//                       "40 to 59"
//                       :
//                       "60 and Above"
                   
//                       }
//                     </span>
//                   </div>
//                 </div>


//                 <div className="details">
//                   <div className='detailItem'>
//                     <span className='itemKey'>Telephone:</span>
//                     <span className='itemValue'>{outletData.userTelephone}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Email:</span>
//                     <span className='itemValue'>{outletData.userEmail}</span>
//                   </div>
//                   <div className='detailItem'>
//                     <span className='itemKey'>Outlet Telephone:</span>
//                     <span className='itemValue'>{outletData.telephone}</span>
//                   </div>
                  
                 
//                 </div> */}


//             </div>
//           </div>
        
//         </div>
//         <div className="top">
//           <div className="left">
//             {/* <div className="editbutton">Edit</div> */}
//             <h2 style={{marginLeft:20, marginTop:20, marginBottom:20, color:'#666'}}>Outlet Photos</h2>
//             <div style={{display:'flex', flexDirection:'row', gap:30, flexWrap:'wrap'}}>

//             {/* <img
//                 src = {outletData.files.map(item => item)}
//                 alt="avatar"
//                 style={{width:'200px', height:'200px'}}
                   
//             />  */}

          
//              {
//               photos.map(item =>(
//                 <div key={item}  style={{position:'relative'}}>
//                   {/* <button onClick={() => handleModal(item)} style={{position:'relative'}}> */}

//                   {/* <button style={{position:'relative'}}> */}

//                   <div onClick={() => deleteUrl(item)}  style={{display:'flex', position:'absolute', top:10, right:10, width:30, height:30, justifyContent:'center', borderRadius:'50%', backgroundColor:'#666', cursor:'pointer'}}><h4 style={{alignSelf:'center', color:'#999'}}>X</h4></div>

//                     <img
                    
//                       key={item}
//                       src = {item}
//                       alt="avatar"
//                       style={{width:'200px', height:'200px', borderRadius:10}}
                    
//                     /> 

//                   {/* </button> */}
                  
//                 </div>
//               ))
//              } 
          
              

//             </div>
//           </div>
//           {/* <div>
//             <Chart 
//               aspect={3/1}
//               title = "Customer purchase last 6 months"
//             />
//           </div> */}
//         </div>


//         <div className="bottom">
       
//         </div>


//       </div>
//     </div>
//   )
// }

// export default Edit